import TYPES from '../../../types';

// Domain
import { CustomerDocumentRepository } from '../../../domain/repositories';
import { InvalidCustomerDocumentBankStatementMagicLinkToken } from '../../../domain/exceptions';
import { VerifyMagicLinkResponse } from '../../../domain/dtos';
import Query from '@/modules/shared/domain/use-cases/query';
import Inject from '@/modules/shared/domain/di/inject';
import Injectable from '@/modules/shared/domain/di/injectable';

@Injectable()
export default class VerifyCustomerDocumentBankStatementMagicLinkToken extends
  Query<Promise<VerifyMagicLinkResponse>, string> {
  @Inject(TYPES.ONBOARDING_CUSTOMER_DOCUMENT_REPOSITORY)
  private readonly customer_document_repository!: CustomerDocumentRepository;

  internalExecute(token: string): Promise<VerifyMagicLinkResponse> {
    return new Promise((resolve, reject) => {
      this.customer_document_repository.verify_magic_link('bank-statement', token)
        .then((data) => {
          if (data.valid) {
            resolve(data);
          } else {
            reject(
              new InvalidCustomerDocumentBankStatementMagicLinkToken('Invalid magic link token'),
            );
          }
        })
        .catch(reject);
    });
  }
}
